import { Box, Card, List } from '@material-ui/core';
import React, { useState } from 'react';
import { CreditLayoutTab } from './creditsLayoutTab';
import { DescriptionTab } from './Description/Description';
import { DiscountsLayout } from './discountsLayoutTab';
import EmailCountdown from './emailCountdown';
import { FeaturedCompetitions } from './FeaturedCompetitions/FeaturedCompetitions';
import { Coupons } from './Coupons/Coupons';
import { GeneralCharitiesTab } from './generalCharitiesTab';
import GeneralFreeTickets from './generalFreeTickets';
import LegalStaffTab from './legalStaffLayoutTab';
import Subscriptions from './Subscriptions';
import OrdersBoostTab from './OrdersBoostTab/ordersBoostTab';
import SubscriptionsBoostTab from './SubscriptionsBoostTab/subscriptionsBoostTab';
import SingleOrderDiscountTab from './SingleOrdersDiscountTab/singleOrdersDiscountTab';

import './style.css';
import SubscriptionsDiscountTab from './SubscriptionsDiscountTab/subscriptionsDiscountTab';

enum GeneralTabsIds {
  Documentations = 'documentations',
  Credits = 'credits',
  FreeTickets = 'freeTickets',
  Discounts = 'discounts',
  Coupons = 'coupons',
  Charities = 'charities',
  EmailCountdown = 'emailCountdown',
  FeaturedCompetitions = 'featuredCompetitions',
  Description = 'description',
  Subscriptions = 'subscriptions',
  OrdersBoost = 'ordersBoost',
  SubscriptionsBoost = 'subscriptionsBoost',
  SingleOrdersDiscount = 'singleOrdersDiscount',
  SubscriptionsDiscount = 'subscriptionsDiscount',
}
const Tabs = [
  {
    title: 'Discount',
    id: GeneralTabsIds.Discounts,
  },
  {
    title: 'Credits',
    id: GeneralTabsIds.Credits,
  },
  {
    title: 'Free Tickets',
    id: GeneralTabsIds.FreeTickets,
  },
  {
    title: 'Subscriptions',
    id: GeneralTabsIds.Subscriptions,
  },
  {
    title: 'Orders Boost',
    id: GeneralTabsIds.OrdersBoost,
  },
  {
    title: 'Single Orders Discount',
    id: GeneralTabsIds.SingleOrdersDiscount,
  },
  {
    title: 'Subscriptions Boost',
    id: GeneralTabsIds.SubscriptionsBoost,
  },
  {
    title: 'Subscriptions Discount',
    id: GeneralTabsIds.SubscriptionsDiscount,
  },
  {
    title: 'Documentations',
    id: GeneralTabsIds.Documentations,
  },
  {
    title: 'Coupons',
    id: GeneralTabsIds.Coupons,
  },
  {
    title: 'Charities',
    id: GeneralTabsIds.Charities,
  },
  {
    title: 'Featured competitions',
    id: GeneralTabsIds.FeaturedCompetitions,
  },
  {
    title: 'Email countdown',
    id: GeneralTabsIds.EmailCountdown,
  },
  {
    title: 'Description (Dreamhome)',
    id: GeneralTabsIds.Description,
  },
];
const GeneralLayout = (props) => {
  const [currentTabId, setCurrentTabId] = useState<string>(
    GeneralTabsIds.Discounts,
  );

  return (
    <Box className='generalTabMainWrapper'>
      <Box className='generalTabsWrapper'>
        <List disablePadding={true}>
          {Tabs.map((i, index) => {
            return (
              <Box onClick={() => setCurrentTabId(i.id)} key={index}>
                <div
                  className={`generalTabWrapper ${
                    i.id === currentTabId ? 'active' : ''
                  }`}
                >
                  {i.title}
                </div>
              </Box>
            );
          })}
        </List>
      </Box>
      <Box className='generalTabContentWrapper'>
        {currentTabId === GeneralTabsIds.Discounts ? <DiscountsLayout /> : null}
        {currentTabId === GeneralTabsIds.Credits ? <CreditLayoutTab /> : null}
        {currentTabId === GeneralTabsIds.Documentations ? (
          <LegalStaffTab />
        ) : null}
        {currentTabId === GeneralTabsIds.FreeTickets ? (
          <Card>
            {' '}
            <GeneralFreeTickets />
          </Card>
        ) : null}
        {currentTabId === GeneralTabsIds.Coupons ? <Coupons /> : null}
        {currentTabId === GeneralTabsIds.Charities ? (
          <GeneralCharitiesTab />
        ) : null}
        {currentTabId === GeneralTabsIds.Description ? (
          <DescriptionTab />
        ) : null}
        {currentTabId === GeneralTabsIds.FeaturedCompetitions ? (
          <FeaturedCompetitions />
        ) : null}
        {currentTabId === GeneralTabsIds.EmailCountdown ? (
          <EmailCountdown />
        ) : null}
        {currentTabId === GeneralTabsIds.Subscriptions ? (
          <Subscriptions />
        ) : null}
        {currentTabId === GeneralTabsIds.OrdersBoost ? (
          <OrdersBoostTab />
        ) : null}
        {currentTabId === GeneralTabsIds.SubscriptionsBoost ? (
          <SubscriptionsBoostTab />
        ) : null}
        {currentTabId === GeneralTabsIds.SingleOrdersDiscount ? (
          <SingleOrderDiscountTab />
        ) : null}
        {currentTabId === GeneralTabsIds.SubscriptionsDiscount ? (
          <SubscriptionsDiscountTab />
        ) : null}
      </Box>
    </Box>
  );
};
export default GeneralLayout;
